
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    pAlertPopInfo: Object as any,
  },
  data() {
    return {
      mPopInfo: {
        title: '알림',
        closeFn: this.pAlertPopInfo.closeFn,
        size: { w: 'auto', h: 'auto' },
        btnList: [
          {
            btnType: 'noBorder',
            btnText: '닫기',
            pointYn: false,
            onClickFn: this.pAlertPopInfo.closeFn,
          },
        ],
        isConfirm: true,
      },
    };
  },
  methods: {},
});
